module.exports = __webpack_public_path__ + "img/v1_ziguanyi.b2efeccf.svg";